import { autoCapitalize } from '@/utils/autoCapitalize'
import { ImmediateAppointmentsQueueListData } from './ImmediateAppointmentQueueMapper.types'
import { replaceValueNotExist } from '@/utils/replaceValueNotExisting'

class ImmediateAppointmentsQueueMapper {
  toDomain(persistenceData: ImmediateAppointmentsQueueListData) {
    return {
      id: persistenceData?.id,
      patientId: persistenceData?.idPaciente,
      patientName: replaceValueNotExist(
        autoCapitalize(persistenceData?.nomePaciente),
      ),
      patientNumber: replaceValueNotExist(persistenceData?.telefone),
      patientAge: persistenceData?.idade,
      clinicName: replaceValueNotExist(
        autoCapitalize(persistenceData?.nomeClinica),
      ),
      specialty: replaceValueNotExist(
        autoCapitalize(persistenceData?.nomeEspecialidade),
      ),
      waitingTime: persistenceData?.tempoEspera,
      inclusionUser: replaceValueNotExist(
        autoCapitalize(persistenceData?.nomeUsuarioInclusao),
      ),
      backofficeUser: persistenceData?.nomeUsuarioBackoffice
        ? autoCapitalize(persistenceData?.nomeUsuarioBackoffice)
        : 'Aguardando responsável',
      backofficeUserId: persistenceData?.idUsuarioBackoffice,
      professionalType: persistenceData?.tipoProfissional?.id,
      professionalId: persistenceData?.idProfissional ?? null,
      awaitingActivation: Boolean(persistenceData?.flagAguardandoAtivacao),
    }
  }
}

export default new ImmediateAppointmentsQueueMapper()
